// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rw6FJ","input":"styles_input__2Ah6j"};